<template>
  <div id="app">
    <router-view>
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: 'Rebar: Modeling & Analytics',
    titleTemplate: '%s: Rebar',
    meta: [
      // Title
      {'vmid': 'twitter:title', 'name': 'twitter:title', 'content': 'Rebar: Modeling & Analytics'},
      {'vmid': 'og:title', 'property': 'og:title', 'content': 'Rebar: Modeling & Analytics'},

      // Description
      {'vmid': 'twitter:description', 'name': 'twitter:description',
       'content': 'Collaboratively understand and build data-driven models for stocks, economics, and more'},
      {'vmid': 'og:description', 'property': 'og:description',
       'content': 'Collaboratively understand and build data-driven models for stocks, economics, and more'},

      // Canonical URL
      {'vmid': 'og:url', 'property': 'og:url', 'content': 'https://www.rebar.ai'},
    ]
  }
}
</script>

<style>
body {
  margin: 0px;
}

h1, h2, h3, button {
  font-family: 'Muli', Avenir, Helvetica, Arial, sans-serif;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
}

button {
  padding: 5px 15px;
  font-weight: bold;
}
</style>
